import { isBrowser } from "./browser.helper";
import { ILocation } from "@montana/shared/map";

export const getUserLocation = (): Promise<ILocation> => new Promise((locationFound, locationNotFound): void => {
    if (!isBrowser) {
        locationNotFound();
    }

    if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
            (position) => locationFound({ lat: position.coords.latitude, lng: position.coords.longitude }),
            locationNotFound,
            {
                maximumAge: Infinity,
                timeout: 15000,
                enableHighAccuracy: false,
            },
        );
    }
});
